import { BaseEntity } from "./BaseEntity";

export default class Manager extends BaseEntity {

    constructor(id: number, public firstName: string, public lastName: string, public email: string, public role: number) {
        super(id);
    }

}